// extracted by mini-css-extract-plugin
export default {"header":"style_header__VBf9d","header_media":"style_header_media__TrJTT","header_main":"style_header_main__7jsH4","content":"style_content__lyyy1","media":"style_media__PI-rH"};